import { EventTypes } from 'redux-segment';

import { aTypeGetProcedureLog } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';
import actionOldBe from 'utils/mw/actionOldBe.util';

const getProcedureLog = actionOldBe((salonId, procedureId) => ({
  api_root: CONF.apiRoot,
  endpoint: `salon/${salonId}/procedures/log/${procedureId}/`,
  authenticated: true,
  types: fromActionTypeToArray(aTypeGetProcedureLog),
  params: { method: 'GET', salonId, procedureId },
  config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  meta: { analytics: EventTypes.track },
}));

export default getProcedureLog;
